import React from "react";
import {LinearProgress, Box, Typography} from "@material-ui/core";
export default function ProgressLlamada({progress, completados}){
    return(
        <Box display="flex"  flexDirection="row" style={{marginTop:1+"em", width:"100%"}}>
            <LinearProgress variant="determinate" value={progress} style={{width:"80%", marginTop:".6em", marginRight:".3em"}}/>
            <Typography style={{width:"30%"}}>{completados + " / 7"}</Typography>
        </Box>
    )
}